import dayjs from "dayjs";

// Codigo de solicitud de vacaciones urgentes. Lo genera este front y lo tipea RRHH en
// Claves Celular para generar el codigo de habilitacion. No es secreto: es un formato
// con digito verificador para que no se tipee mal.
//
//   LLLLL DD MM V  →  legajo a 5 digitos, dia y mes de inicio, digito Luhn de los 9 anteriores
//
// Contrato: ClavesDescuento-Menu/docs/plans/2026-09-11-vacaciones-urgente-design.md
export const CodigoSolicitud = {
  /** Digito verificador Luhn de una cadena de digitos. */
  luhn(digitos) {
    let suma = 0;
    for (let i = 0; i < digitos.length; i++) {
      // Se recorre de derecha a izquierda: el primero de la derecha, el tercero, ... se duplican
      let d = Number(digitos[digitos.length - 1 - i]);
      if (i % 2 === 0) {
        d *= 2;
        if (d > 9) d -= 9;
      }
      suma += d;
    }
    return String((10 - (suma % 10)) % 10);
  },

  /** "1234515102" */
  generar(legajo, fechaInicio) {
    const n = Number(legajo);
    if (!Number.isInteger(n) || n < 1 || n > 99999) throw new Error("Legajo fuera de rango: " + legajo);
    const f = dayjs(fechaInicio);
    const cuerpo = String(n).padStart(5, "0") + f.format("DD") + f.format("MM");
    return cuerpo + CodigoSolicitud.luhn(cuerpo);
  },

  /** "12345 1510 2" — para leerlo facil. */
  formatear(codigo) {
    return codigo.slice(0, 5) + " " + codigo.slice(5, 9) + " " + codigo.slice(9);
  },
};
